import { DateFormatter } from '@components'

import { Text } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { BillStatus } from '@features/bills/enums/billStatus'

import { getPassedTimeText } from '../../../../../../utils/getPassedTimeText'

interface BillPaymentPaneExtraProps {
  date: string | null
  status: BillStatus
}

export const BillPaymentPaneExtra = ({ date, status }: BillPaymentPaneExtraProps): ReactElement | null => {
  const { t } = useTranslation()

  if (date) {
    if (status === BillStatus.Paid || status === BillStatus.Draft) {
      return (
        <Text colorVariant="secondary" variant="bodySM">
          <DateFormatter value={date} />
        </Text>
      )
    }

    if (status === BillStatus.Unpaid) {
      return (
        <>
          <Text colorVariant="secondary" variant="bodySM">
            {t('bills.view.payment_pane.due')}
          </Text>
          <Text colorVariant="secondary" variant="bodySM">
            <DateFormatter value={date} />
          </Text>
        </>
      )
    }

    if (status === BillStatus.Overdue) {
      const passedTimeText = getPassedTimeText(date, t)

      return (
        <Text variant="bodySM" colorVariant="danger" truncate>
          {passedTimeText}
        </Text>
      )
    }
  }

  return null
}
